var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from 'aurelia-dependency-injection';
import { NotifyPropertyChangedBase } from '../../../../utilities/reflection';
import { DialogClientService } from '../../../../services/basics/dialog-client.service';
import { DashboardClientService } from '../../../../services/dashboard/dashboard-client.service';
var ManageDashboardDialog = /** @class */ (function (_super) {
    __extends(ManageDashboardDialog, _super);
    function ManageDashboardDialog(dialogClient, dashboardClientService) {
        var _this = _super.call(this) || this;
        _this.dialogClient = dialogClient;
        _this.dashboardClientService = dashboardClientService;
        _this.isReadOnly = false;
        return _this;
    }
    ManageDashboardDialog.prototype.cancel = function () {
        this.dialogClient.hide();
    };
    ManageDashboardDialog.prototype.saveDashboard = function () {
        var _this = this;
        this.dashboard.isReadonly = this.isReadOnly;
        this.dashboardClientService.persistDashboardMetaData(this.dashboard).then(function (response) {
            //reload
            _this.dashboardsVm.load();
            _this.dialogClient.hide();
        });
    };
    ManageDashboardDialog.prototype.activate = function (model) {
        if (model.item) {
            this.dashboard = model.item;
            this.isReadOnly = this.dashboard.isReadonly;
        }
        else {
            this.dashboard = {
                id: 0,
                createdDate: new Date(),
                dashboardId: 0,
                dashboardWidgets: [],
                name: "",
                atRoleLevel: false,
                isGlobal: true,
                isReadonly: false
            };
        }
        this.dashboardsVm = model.vm;
    };
    ManageDashboardDialog = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [DialogClientService, DashboardClientService])
    ], ManageDashboardDialog);
    return ManageDashboardDialog;
}(NotifyPropertyChangedBase));
export { ManageDashboardDialog };
